import React from "react";
import "uq-global-ec-uikit/components/dist/css/main.global.css";
import "uq-global-ec-uikit/components/dist/css/main.fonts.css";
import "uq-global-ec-uikit/components/dist/css/main.css";
import * as globalJS from "uq-global-ec-uikit/components/dist/js/main.global.js";
import zh_HK from "fr-global-stylingbook-wording/wording/UQ-zh-HK";
import zh_TW from "fr-global-stylingbook-wording/wording/UQ-zh-TW";
import en_GB from "fr-global-stylingbook-wording/wording/UQ-en-HK";
import i18nInit from "../../../util/i18n";

globalJS.keyboardOnlyFocus();

const resources = {
  "zh-HK": { translation: zh_HK },
  "zh-TW": { translation: zh_TW },
  "en-GB": { translation: en_GB }
};
i18nInit(resources);

const UQLayout = (props: any): any => <div>{props.children}</div>;

export default UQLayout;
